// extracted by mini-css-extract-plugin
var _1 = "Settings_text__xpiXU";
export { _1 as "text" }
